import { render } from "./ServicesTab.vue?vue&type=template&id=803c448e"
import script from "./ServicesTab.vue?vue&type=script&lang=js"
export * from "./ServicesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__